import { render, staticRenderFns } from "./shipmentDetail.vue?vue&type=template&id=58a36ddb&scoped=true&"
import script from "./shipmentDetail.vue?vue&type=script&lang=js&"
export * from "./shipmentDetail.vue?vue&type=script&lang=js&"
import style0 from "./shipmentDetail.vue?vue&type=style&index=0&id=58a36ddb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a36ddb",
  null
  
)

export default component.exports